import React, { useRef, useState } from 'react';
import { ZdsButton, ZdsDivider } from '@zig-design-system/ui-components-react';
import ProjectResult from './results/ProjectResult';
import ActionResult from './results/ActionResult';
import FaqResult from './results/FaqResult';
import UnitResult from './results/UnitResult';
import ComplexResult from './results/ComplexResult';
import Translation from '../../Shared/components/Translation';
import DownloadResult from './results/DownloadResult';
import OtherResult from './results/OtherResult';
const Result = ({ section, hits }) => {
    const [showAll, setShowAll] = useState(false);
    const ref = useRef(null);
    const handleRevealButton = () => {
        var _a;
        setShowAll(!showAll);
        if (showAll)
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    const defaultResultsThreshold = 3;
    const filteredHits = showAll ? hits : hits.slice(0, defaultResultsThreshold);
    return (React.createElement("div", { ref: ref },
        React.createElement("h4", { className: "zds-headline-md zds-margin-bottom-3" },
            React.createElement(Translation, { item: section.title })),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" }),
        React.createElement("div", null, filteredHits.map((hit) => {
            switch (section.name) {
                case 'action':
                    return React.createElement(ActionResult, { key: hit._id, hit: hit });
                case 'project':
                    return React.createElement(ProjectResult, { key: hit._id, hit: hit });
                case 'faq':
                    return React.createElement(FaqResult, { key: hit._id, hit: hit });
                case 'unit':
                    return React.createElement(UnitResult, { key: hit._id, hit: hit });
                case 'complex':
                    return React.createElement(ComplexResult, { key: hit._id, hit: hit });
                case 'download':
                    return React.createElement(DownloadResult, { key: hit._id, hit: hit });
                case 'other':
                    return React.createElement(OtherResult, { key: hit._id, hit: hit });
                default:
                    return null;
            }
        })),
        hits.length > defaultResultsThreshold && (React.createElement(ZdsButton, { className: "zds-margin-top-4", variant: "outlined", onZdsClick: handleRevealButton }, showAll ? (React.createElement(Translation, { item: "tx_zigsitepackage.search.showLess" })) : (React.createElement(Translation, { item: "tx_zigsitepackage.search.showMore" }))))));
};
export default Result;
